<script>
  import Upload from '@/components/Upload';
  import AppSwitch from '@/components/Switch';

  export default {
    components: {
      Upload,
      AppSwitch,
    },

    data: () => ({
      selected: 0,
    }),

    computed: {
      infos () {
        return [
          'Todos os documentos enviados devem pertencer ao titular da conta.',
          'Utilize apenas imagens no formato: <br> PNG, JPG, JPEG ou PDF.',
          'Cada arquivo deve ter no máximo 5 MB.',
          'Utilize ambientes claros e com boa iluminação para tirar sua foto.',
          'Tente tirar a foto o mais frontal possível.',
        ];
      },

      switches () {
        return [
          'Carteira de Motorista',
          'Identidade',
        ];
      },
    },
  };
</script>

<template>
  <div class="document">
    <header class="document__header">
      <h1 class="document__header-title">Envio de documentos</h1>

      <RouterLink
        to="/"
        class="document__header-link"
        >
        PULAR ESSE PASSO
      </RouterLink>
    </header>

    <main class="document__content">
      <div class="document__left">
        <h2 class="document__left-title">Forneça um documento de identificação</h2>

        <AppSwitch
          v-model="selected"
          :options="switches"
          class="document__left-switch"
          />

        <div class="document__left-upload">
          <Upload
            webcam
            title="Frente"
            >
            <span class="document__left-placeholder">Enviar arquivo</span>
          </Upload>

          <Upload
            webcam
            title="Verso"
            >
            <span class="document__left-placeholder">Enviar arquivo</span>
          </Upload>
        </div>
      </div>

      <div class="document__right">
        <h2 class="document__right-title">Informações importantes</h2>

        <ul class="document__right-list">
          <li
            :key="info"
            v-html="info"
            v-for="info in infos"
            class="document__right-item"
            >
          </li>
        </ul>
      </div>
    </main>

    <RouterLink
      to="/dashboard"
      class="document__action"
      >
      Confirmar
    </RouterLink>
  </div>
</template>

<style lang="scss">
  .document {
    display: flex;
    margin: 0 auto;
    padding: 54px 0;
    max-width: 984px;
    flex-direction: column;

    &__header {
      display: flex;
      align-items: center;
      margin-bottom: 32px;

      * {
        color: #FFF;
        font-weight: 500;
      }

      &-title {
        font-size: 32px;
        letter-spacing: 0.64px;
      }

      &-link {
        padding: 16px;
        font-size: 13px;
        margin-left: auto;
        line-height: 0.92;
        border-radius: 4px;

        &:hover {
          background-color: rgba(#FFF, .1);
        }
      }
    }

    &__content {
      padding: 54px;
      display: flex;
      border-radius: 4px;
      margin-bottom: 40px;
      background-color: rgba(#FFF, .08);
    }

    &__left {
      width: 480px;
      padding-right: 72px;

      &-title {
        color: #FFF;
        margin-bottom: 32px;
        letter-spacing: 0.32px;
      }

      &-switch {
        margin-bottom: 67px;
      }

      &-upload {
        display: flex;
        justify-content: space-between;
      }

      &-placeholder {
        font-size: 20px;
        color: #b2b8c5;
      }
    }

    &__right {
      flex: 1;
      padding-left: 72px;
      border-left: 3px dotted #494b5f;

      &-title {
        color: #FFF;
        margin-bottom: 32px;
        letter-spacing: 0.32px;
      }

      &-list {
        max-width: 310px;
        list-style: initial;
      }

      &-item {
        color: #c1c2d9;
        font-size: 14px;
        line-height: 1.29;
        margin-bottom: 32px;
      }
    }

    &__action {
      color: #FFF;
      margin-left: auto;
      padding: 12px 26px;
      border-radius: 4px;
      letter-spacing: 0.32px;
      background-color: #3e388b;

      &:hover {
        background-color: #322c76;
      }
    }
  }
</style>
